import { useState } from "react";
import { extractAllContent, extractContent } from "../shared/utils/ExtractionUtils";
import * as cheerio from "cheerio";
import TurndownService from "turndown";
import { PiBrainDuotone, PiCopy, PiHashDuotone } from "react-icons/pi";
import { getGeminiCompletion } from "../ai/GeminiUtils";
import MarkdownRenderer from "../tasks/components/MarkdownRenderer";

interface DocSection {
  title: string;
  html?: string;
  content?: string;
}

export default function ExtractionDemo() {
  var turndownService = new TurndownService();

  const [content, setContent] = useState<string[] | string>([]);
  const [url, setUrl] = useState<string>("");
  const [title, setTitle] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [image, setImage] = useState<string>("");
  const [sections, setSections] = useState<DocSection[]>([]);
  const [h1s, setH1s] = useState<number>(0);
  const [h2s, setH2s] = useState<number>(0);
  const [h3s, setH3s] = useState<number>(0);
  const [markdown, setMarkdown] = useState<boolean>(true);
  const [loadingUrl, setLoadingUrl] = useState<boolean>(false);
  const [loadedContent, setLoadedContent] = useState<string>();

  return (
    <div className="p-16">
      <div className="flex gap-4 items-center mb-8">
        <input
          className="input input-bordered"
          title="url"
          type="text"
          value={url}
          onChange={(e) => {
            setUrl(e.target.value);
          }}
        ></input>
        <button
          className="btn btn-primary"
          disabled={!url}
          onClick={() => {
            setLoadingUrl(true);
            extractAllContent(url)
              .then((content) => {
                console.log(content.length);
                const $ = cheerio.load(content);
                const article = $("article");
                console.log("cheerio", article.text());
                setLoadedContent( article.text());
                const title = extractTitle($);
                const image = extractImage($);
                const description = extractDescription($);
                const sections = getSections($, url);
                const sectionOne = extractSectionOne($);

                setLoadingUrl(false);
                setTitle(title ?? "");
                setDescription(description ?? "");
                setImage(image ?? "");
                setSections(sections);
                setContent(content);
              })
              .catch((e) => {
                console.error("Error extracting content", e);
                setLoadingUrl(false);
              });
          }}
        >
          Extract
        </button>
        <button
          className="btn btn-outline"
          onClick={() => {
            console.log(
              "loadedContent",
              loadedContent
            );
            navigator.clipboard.writeText(
              loadedContent ?? ""
            );
          }}
        >
          Copy
        </button>
        {loadingUrl && <div className="loading-lg loading"></div>}
      </div>
      <div className="flex">
        <div className="w-1/2">
          <div>Title : {title}</div>
          <div>Description : {description}</div>
          <div>Image : {image}</div>
          {image && (
            <img
              src={image}
              alt="image"
              className="w-1/4"
            />
          )}
        </div>
        <div className="w-1/2">
          <div>Header 1s : {h1s}</div>
          <div>Header 2s : {h2s}</div>
          <div>Header 3s : {h3s}</div>
        </div>
      </div>

      {sections && sections.length > 0 && (
        <div className="mt-8 ">
          <div className="flex items-center gap-4 ">
            <h1 className="text-2xl font-bold ">Sections</h1>
            <input
              title="markdown"
              type="checkbox"
              className="toggle"
              onChange={(e) => {
                setMarkdown(e.target.checked);
              }}
              checked={markdown}
            />
          </div>
          {sections.map((section, i) => {
            return (
              <div
                key={i}
                className="p-4 shadow-md rounded-md my-4"
              >
                <div className="title-xl font-bold">{section.title}</div>
                {!markdown && (
                  <div className="leading-7 py-2">{section.content}</div>
                )}
                {markdown && (
                  <MarkdownRenderer
                    content={turndownService.turndown(section.html!)}
                  ></MarkdownRenderer>
                )}
                <div className="flex items-center justify-end gap-4">
                  <PiCopy
                    size={24}
                    className="cursor-pointer"
                    onClick={() => {
                      navigator.clipboard.writeText(section.content ?? "");
                    }}
                  />
                  <PiHashDuotone size={24} />
                  <PiBrainDuotone
                    size={24}
                    className="cursor-pointer"
                    onClick={async () => {
                      const response = await getGeminiCompletion({
                        prompt: `Summarize this section: ${section.content}`,
                      });

                      console.log("response", response);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* {content && typeof content === "string" && (
        <p className="leading-7 py-2">{content}</p>
      )}
      {content &&
        Array.isArray(content) &&
        content.map((e) => {
          return <p className="leading-7 py-2">{e}</p>;
        })} */}
    </div>
  );

  function extractSectionOne(html: cheerio.CheerioAPI) {
    let data = html(".markdown-heading:eq(1)");
    console.log("heading", data.text(), data.length);
    console.log("next", data.next().text());

    console.log("nextUntil", data.nextUntil(".markdown-heading").text());
    return data;
  }

  function extractTitle(html: cheerio.CheerioAPI) {
    let data = html("title").text();

    console.log("data", data);
    if (!data) {
      data = html("meta").attr("property", "og:title").text();
    }
    return data;
  }

  function extractDescription(html: cheerio.CheerioAPI) {
    let data = html('meta[name="description"]').attr("content");

    console.log("data", data);

    return data;
  }

  function extractImage(html: cheerio.CheerioAPI) {
    let data = html('meta[property="og:image"]').attr("content");
    console.log("data", data);

    if (!data) {
      data = html('meta[property="twitter:image"]').attr("content");
    }

    return data;
  }

  function getSections(html: cheerio.CheerioAPI, url: string): DocSection[] {
    let data: DocSection[] = [];

    const h1s = html("h1").length;
    const h2s = html("h2").length;
    const h3s = html("h3").length;

    console.log("h1s", h1s);
    console.log("h2s", h2s);
    console.log("h3s", h3s);

    setH1s(h1s);
    setH2s(h2s);
    setH3s(h3s);

    if (url.includes("github.com")) {
      data = html(".markdown-heading")
        .map((x, e) => {
          const title = html(e).text();
          const content = html(e).nextUntil(".markdown-heading");
          return {
            title: title,
            html: content
              .map((i, x) => html(x).html())
              .get()
              .join(" "),
            content: content
              .map((i, x) => html(x).text())
              .get()
              .join(" "),
          };
        })
        .get();

      return data;
    } else {
      let tag: string = "h1";
      if (h1s > h2s && h1s > h3s) {
        tag = "h1";
      } else if (h2s > h1s && h2s > h3s) {
        tag = "h2";
      } else {
        tag = "h3";
      }

      data = html(tag)
        .map((x, e) => {
          const title = html(e).text();
          const content = html(e).nextUntil(tag);
          return {
            title: title,
            html: content
              .map((i, x) => html(x).html())
              .get()
              .join(" "),
            content: content
              .map((i, x) => html(x).text())
              .get()
              .join(" "),
          };
        })
        .get();

      return data;
    }
  }
}
